module.exports = __webpack_public_path__ + "img/background-quizz.faf2ff43.jpg";